import type { HTMLAttributes, MouseEvent as ReactMouseEvent, ReactNode } from 'react';
import { handleRichTextLinkClick } from './richTextRenderer';

export type RichTextContentProps = Omit<
  HTMLAttributes<HTMLDivElement>,
  'dangerouslySetInnerHTML'
> & {
  html: string;
};

/**
 * Container for generated rich-text HTML.
 *
 * The single place rendered rich text enters the DOM, so link activation
 * (popup sizing, URL validation, mailto pass-through) applies uniformly to
 * every block renderer instead of being opted into per call site.
 *
 * All other div props — className, style, data-testid, role, aria-* — forward
 * through untouched. className in particular is load-bearing: it keys the
 * reset styles produced by createRichTextContentResetStyles.
 */
export function RichTextContent({
  html,
  onClick,
  ...rest
}: RichTextContentProps): ReactNode {
  const handleClick = (event: ReactMouseEvent<HTMLDivElement>): void => {
    handleRichTextLinkClick(event);
    onClick?.(event);
  };

  return (
    <div
      {...rest}
      onClick={handleClick}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
